import "./MainHeader.scss";
import logo from "../../../../images/logo.png"

const MainHeader = () => {

    return (
        <div className="main-header">
            <img src={logo} alt="Logo" />
            <h1>Map Web Tool</h1>
        </div>
    )
}

export default MainHeader;